import { createRoot } from 'react-dom/client';

import '@ui-components/neo.tax/dist/tailwind.css';

import { AppRouter } from './base';
import { AgentationWidget } from './shared/third-parties/agentation/AgentationWidget';

// AppRouter must be highest level component in order for Sentry error boundary to take effect before
// react-router-dom's error boundary. In other words, react router must wrap App.
// AgentationWidget is a dev-only tool rendered as a sibling of AppRouter. It guards itself
// with its own ErrorBoundary (see AgentationWidget.tsx) so a widget bug can't crash the app.
const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');
createRoot(container).render(
  <>
    <AppRouter />
    <AgentationWidget />
  </>,
);
